module.exports = __webpack_public_path__ + "static/img/usinessPartner_05_m.6f3d163b.jpg";